// extracted by mini-css-extract-plugin
module.exports = {"form_container":"style_form_container__2ha3U","buttons_container":"style_buttons_container__2JQIY","button":"style_button__3E1mv"};